import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import CopyToClipboard from 'react-copy-to-clipboard'
import { TextInput,
  Text,
  Flex,
  LabelGroup,
  Section } from '~/views'

import { GeotileActions } from '~/actions/'
import { Geotile as GeotileUtil } from '../../utils'

import style from './style.css'

class GeotileInfoEditor extends React.Component {
  static propTypes = {
    geotile : PropTypes.object.isRequired,
  }

  update = ( body ) => {
    const { dispatch, projectId, geotile : { id : geotileId } } = this.props
    dispatch( GeotileActions.update( { geotileId, projectId, body } ) )
  }

  changePath = ( path, value, err ) => {
    const body = new FormData()
    body.append( path, value )
    this.update( body )
  }

  changeMetadata = ( field, value ) => {
    const { geotile } = this.props
    const { metadata = {} } = geotile
    const nMeta = { ...metadata, [field] : value }
    const body = new FormData()
    body.append( 'metadata', JSON.stringify( nMeta ) )
    this.update( body )
  }

  formatLayerDataForDisplay = ( layerData ) => {
    return JSON.stringify( layerData, null, 2 )
  }

  onSelectImage = e => this.props.onSelectImage( e )

  render() {
    const { geotile } = this.props
    const { metadata = {}, sourceImagePath } = geotile
    const layerData = GeotileUtil.getLayerData( geotile )

    return (
      <>
        <Section>
          <Flex variant="vSpace" align="stretch" direction="column">
            <LabelGroup>
              <label>ID</label>
              <Text type="dim" text={geotile.id} />
            </LabelGroup>
            <LabelGroup>
              <label>Name</label>
              <TextInput
                value={geotile.name}
                changeOnReturn
                size={10}
                onChange={( v, err ) => { this.changePath( 'name', v, err ) }} />
            </LabelGroup>
            <LabelGroup>
              <label>Description</label>
              <TextInput
                value={metadata?.description || ''}
                changeOnReturn
                size={10}
                onChange={( v, err ) => { this.changeMetadata( 'description', v, err ) }} />
            </LabelGroup>
            { sourceImagePath && (
              <LabelGroup>
                <label>Image</label>
                <div className={style.thumbnailSmall}><img src={sourceImagePath} /></div>
              </LabelGroup>
            )}
          </Flex>
        </Section>
        {
          layerData && (
            <Section title="Layer Data" titleOnTop>
              <pre className={style.code}>
                {this.formatLayerDataForDisplay( layerData )}
              </pre>
              <CopyToClipboard text={JSON.stringify( layerData )} onCopy={this.copied}>
                <button>
                  {' '}
                  <i className="fa fa-copy fa-fw" />
                  {' '}
                  Copy to Clipboard
                  {' '}
                </button>
              </CopyToClipboard>
            </Section>
          )
        }
      </>
    )
  }
}

export default connect( state => ( {
  geotile : state.geotile || {},
  projectId : state.project.id
} ) )( GeotileInfoEditor )
